import { gql, TypedDocumentNode } from '@apollo/client';
import type { Item } from '../models/Item';

export const ADD_ITEM_MUTATION: TypedDocumentNode<{ added: boolean }, { input: Item }> = gql`
  mutation AddItem($input: ItemModelInput!) {
    added: addItem(input: $input)
  }
`;

export const UPDATE_ITEM_MUTATION: TypedDocumentNode<{ updatedItem: Item }, { id: number, input: Item }> = gql`
  mutation UpdateItem($id: Int!, $input: ItemModelInput!) {
    updatedItem: updateItem(id: $id, input: $input) {
      id,
      name,
      description
    }
  }
`;

export const DELETE_ITEM_BY_ID_MUTATION: TypedDocumentNode<{ deleted: boolean }, { id: number }> = gql`
  mutation DeleteItemById($id: Int!) {
    deleted: deleteItemById(id: $id)
  }
`;
